export default {
  isDeploymentEnvProduction() {
    return process.env.VUE_APP_DEPLOY_ENV === 'production';
  },
  isDeploymentEnvStaging() {
    return process.env.VUE_APP_DEPLOY_ENV === 'staging';
  },
};
